export function hexToDecimal(hexNumber: string): number {
    return parseInt(hexNumber, 16)
}
